<template>
	<div class="goods-form-wrapper">
		<div class="header-sidebar mb-4" slot="header">
			<h4 class="pull-left">
				<!--{{ $t('Create goods') }}-->
				{{ $t('sidebar.warehouse-management.sector') }}
			</h4>
			<b-button class="pull-right close-btn" @click="cancel" type="button" variant="link"><i
				class="fa fa-close"></i></b-button>
			<div class="clearfix"></div>
			<hr>
		</div>

		<form v-on:submit="create">
			<b-row>
				<b-col cols="6">
					<b-form-group
						breakpoint="lg"
						label-cols="4"
						label-cols-lg="2"
						label-size="sm"
						class=""
					>
						<template slot="label">
							{{ $t('goods.create.name') }} <span class="text-danger"> * </span>
						</template>
						<b-form-input id="name"
									  size="sm"
									  v-model="item.name"
									  name="name"
									  :placeholder="$t('goods.create.name')"></b-form-input>
					</b-form-group>
				</b-col>



				<b-col cols="1">
					<label class="col-form-label  pt-0 col-form-label-sm  pt-0">{{$t('priceControl.departments')}} <span class="text-danger"> * </span> </label>
				</b-col>
				<b-col cols="5">
					<multiselect
						v-model="item.departmentId"
						:options="departments"
						:searchable="true"
						track-by="id"
						:show-labels="false"
						:allow-empty="true"
						label="name"
						:placeholder="$t('priceControl.departments')"
						class="multiselect-pricing"
					>
					</multiselect>
				</b-col>
			</b-row>

			<hr>
			<b-form-group breakpoint="lg"
						  label-cols="2"
						  :label="$t('comment')"
						  label-size="sm">
				<b-textarea v-model="item.comment"></b-textarea>
			</b-form-group>

			<div class="modal-actions">
				<b-row class="align-items-center">
					<b-col cols="6" class="mb-3 mb-xl-0">
						<b-row>
							<b-col cols="6">
								<b-button block size="sm" type="button" @click="cancel" variant="outline-danger">{{
									$t('cancel') }}
								</b-button>
							</b-col>
							<b-col cols="6">
								<b-button block type="button" size="sm" @click="create" variant="primary">{{ $t('save')
									}}
								</b-button>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
			</div>


		</form>
	</div>
</template>

<script>

	import Multiselect from 'vue-multiselect'
	import  {TokenService } from "../../../services/storage.service";
	import UsersService from "../../../services/users.sevice";


	export default {
		name: 'NewSector',


		props: {
			mode: {
				type: String,
				default: 'create'
			},
			item: {
				type: Object,
				default: null
			}

		},

		data: () => {
			return {
				departments:[]
			}
		},

		async created() {
			await this.getDeps();
			await this.setDep();
		},

		/**
		 * Methods
		 */
		methods: {
			create() {
				if(!this.item.name || !this.item.departmentId){
					this.$vs.notify({
						title: this.$t('words.error'),
						text: this.$t('words.validation-error'),
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					})
				}else{
					this.$emit('save', this.item);
				}

			},

			cancel() {
				this.$emit('close', true);
			},
			async getDeps()
			{
				await UsersService.getPermittedDepartments(TokenService.getCurrentUserId()).then(response => {
					this.departments =  response.data.permittedDepartments
				})
			},

			async setDep(){
				if(this.item.departmentId){
					this.item.departmentId = this.departments.filter(el => el.id === this.item.departmentId);
				}


			}
		},

		computed: {},


		components: {

			Multiselect
		}
	}
</script>
<style scoped>

</style>

